import React from 'react';

import { PageTitle } from 'modules/checkout/presentation/components/atoms';
import { useLocale } from 'shared/presentation/contexts';

import * as S from './styles';

const PageWrapper: React.FC = ({ children }) => {
  const { t } = useLocale('shared');

  return (
    <S.Container>
      <main>
        <PageTitle
          title={t('We need to verify your identity!')}
          subtitle={t(
            'The process is fast and you only need to pass through it once for this process',
          )}
        />
        <section>{children}</section>
      </main>
    </S.Container>
  );
};

export default PageWrapper;
